import { useEffect } from 'react';

export function injectJsonLd(id: string, data: unknown) {
  document.getElementById(id)?.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function useJsonLd(id: string, data: unknown | null | undefined) {
  const key = JSON.stringify(data ?? null);
  useEffect(() => {
    if (data) {
      injectJsonLd(id, data);
    } else {
      document.getElementById(id)?.remove();
    }
    return () => {
      document.getElementById(id)?.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, key]);
}